
let _ = require('../_.js');
let $ = jQuery;


_.Lib_Auction_Bids = class Lib_Auction_Bids {

    // User is registered and approved to bid AND auction is open for bids
    // Todo: Make this calculated server side like best_bid_by_user
    static async can_bid(round) {
        try {
            if (!_.ac_state.registrant) {
                return false;
            }

            let ura = this.user_registration_approved();
            let aab = this.auction_accepting_bids(round);

            // let ubp = await this.user_bid_pending(item);

            let return_code = ura && aab; // !ubp

            return return_code;
        } catch (e) {
            console.error(e);
            return false;
        }
    }

    // Returns the current pending bid for the user, or false if none
    // Todo: Make this calculated server side like best_bid_by_user
    static async user_bid_pending(_round) {

        let round = await _round.private();

        let bid_id = round.user_bid_pending;

        if (!bid_id) {
            return null;
        }

        return await App_Models_Bid.get_private(bid_id);
    }

    // Returns the current active max bid for current user, if any.
    static async user_bid_max(_round) {

        let round = await _round.private();

        let bid_id = round.user_bid_max;

        if (!bid_id) {
            return null;
        }

        return await App_Models_Bid.get_private(bid_id);
    }


    // Returns either the users approved winning bid, or the higest pending / outbid bid, whichever is better.
    // Used to represent the current user's 'bid' so they can see if they are winning (yay!) or outbid (red lettering oh no's!)
    // The calculation for this is now done server side as a part of fetching the auction round.
    static async best_bid_by_user(_round) {

        if (!_.ac_state.registrant) {
            return null;
        }

        let round = await _round.private();

        let bid_id = round.best_bid_by_user_id;

        if (!bid_id) {
            return null;
        }

        return await App_Models_Bid.get_private(bid_id);
    }

    // User is registered and approved to bid
    static user_registration_approved() {
        try {
            return _.ac_state.registrant &&
                _.ac_state.registrant.id &&
                _.ac_state.registration &&
                _.ac_state.registration.approved;
        } catch (e) {
            console.error(e);
            return false;
        }
    }

    // Auction is open for bids
    static auction_accepting_bids(round) {
        try {
            return round.status_can_bid;
        } catch (e) {
            console.error(e);
            return false;
        }
    }


    // Returns total number of actual bids for an item for any user (not deleted)
    static async count_total_bids(round) {
        // Todo: This can be de-abstracted.
        return round.total_bids_accepted;
    }

    static get_registration_by_registrant_id = async function (registrant_id) {

        if (!_.ac_state.auction) return false;

        let registrations = await _.ac_state.auction.auction_registrations.fetch();

        for (let i in registrations) {
            if (registrations[i].registrant_id == registrant_id) {
                return registrations[i];
            }
        }

        return false;
    }
}